import { Meta, theme } from 'aimo-ui';
import Icon from 'components/icons/Icon';
import { SelectedPaymentMethod } from 'hooks/useSelectedPaymentMethod';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { CenterVerticalRow } from 'styles/ContainerStyles';
import { Maybe, SalesOrderPaymentMethod } from 'types/generatedSchemaTypes';
import { getWalletCardMenuPresentation } from 'utils/paymentUtils';
import TicketRow from './TicketRow';

type PaymentMethodDisplayProps = {
  uid?: string;
  paymentMethod?: Maybe<SalesOrderPaymentMethod>;
  paymentCard?: SelectedPaymentMethod;
};

const PaymentMethodRow = ({
  uid,
  paymentMethod,
  paymentCard,
}: PaymentMethodDisplayProps) => {
  const { t } = useTranslation();
  const creditCardNums = paymentCard?.lastNums;
  const walletCard =
    paymentMethod === 'CREDIT_CARD'
      ? getWalletCardMenuPresentation(paymentCard, t)
      : undefined;
  const getDisplayValueForPaymentMethod = (): string => {
    if (!paymentMethod) return '';

    if (paymentMethod === 'CREDIT_CARD') {
      if (walletCard) return walletCard.subtitle;
      return creditCardNums
        ? '**** ' + creditCardNums
        : t('payment.creditCardMissing');
    }

    return t('paymentMethods.invoicing');
  };

  const displayValue = getDisplayValueForPaymentMethod();

  return (
    <TicketRow
      title={t('services.paymentMethod')}
      testID={`permit-${uid}-payment-method`}>
      <CenterVerticalRow gap={5}>
        {walletCard && <Icon name={walletCard.iconName} size="m" />}
        <Meta
          color={
            walletCard || creditCardNums
              ? theme.colors.black
              : theme.colors.boost.red
          }>
          {displayValue}
        </Meta>
      </CenterVerticalRow>
    </TicketRow>
  );
};

export default PaymentMethodRow;
